import requestTimeout from './common/requestTimeout';
import verge from 'verge';
import throttle from './common/throttle';
import { CountUp } from 'countup.js';

const SELECTORS = Selectors({
  counter: '[data-counter]',
  wrapper: '.stats-items',
});

const counters = document.querySelectorAll(SELECTORS.counter);

const state = {
  counters: [],
};

const fn = {
  init: () => {
    counters.forEach(el => {
      const useGrouping = el.dataset.useGrouping;
      const decimalPlaces = el.dataset.decimalPlaces;
      const end = el.dataset.end;

      const opts = {
        useGrouping: !!+useGrouping,
      };

      if (decimalPlaces) {
          opts.decimalPlaces = decimalPlaces;
      }

      const counter = new CountUp(el, end, opts);
      counter._el = el;

      state.counters.push(counter);
    });

    // fn.bindEvents();
    // fn.update();
    setInterval(throttle(fn.update, 5000), 3000);
  },

  bindEvents: () => {
    window.addEventListener('scroll', throttle(fn.update, 250));
  },

  update: () => {
    state.counters.forEach((counter, index) => {
      if (verge.inY(counter._el)) {
        counter.reset();
        setTimeout(counter.start(), 500)
        setTimeout(null, 5000);
        // delete state.counters[index];
      }
    });
  },
};

export default {
  can: () => counters.length,
  run: fn.init,
};
